import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './form.css';
import MysketchPicker from '../../../components/MysketchPicker/MysketchPicker';

import colors from './colors'
import Collapse, { Panel } from '../../../components/Collapse/Collapse';

const str2json = (str) => str.replace(/(\S+)\s+(\S+)/g, (str, name, value) => {
  return `{"name": "${name}","value": ${value}}`
})
const num2Str = ['一', '二', '三', '四']

const parseStr = (list = '') => {
  if (list === '') return []

  return list.split(/\n/).filter(item => item != '').map(item => {
    const _item = JSON.parse(str2json(item))
    return {
      name: _item.name,
      value: _item.value
    }
  })
}

const obj2str = (list) => {
  return list.map((item, index) => {
    return `${item.name} ${item.value}`
  }).join('\n')
}

const concat = (...args) => {
  let list = []
  args.forEach((item, index) => {
    const _item = parseStr(item).map(ele => {
      // @ts-ignore
      ele.floor = index
      return ele;
    })
    
    list.push(..._item)
  })
  return list
}


const inputStyle = {
  height: 24,
  padding: '2px 7px',
  boxSizing: 'border-box',
  verticalAlign: 'middle',
  marginRight: 10
}


class KeyValuePie extends Component {
  constructor (props) {
    super(props);
    
    const {labelList, list, fontSizes} = props.data
    const ll = list.map((item, index) => ({
      name: labelList[index],
      arr: obj2str(item),
      arr0: obj2str(item.filter(ele => ele.floor === 0)),
      arr1: obj2str(item.filter(ele => ele.floor === 1)),
      arr2: obj2str(item.filter(ele => ele.floor === 2)),
      arr3: obj2str(item.filter(ele => ele.floor === 3)),
    }))

    this.state = {
      beginTime: '2019-03-01',
      endTime: '2019-03-27',
      agreeable: '',
      reverse: '',
      axis: 'horizontal',
      list: ll,
      colors: colors,
      fontSizes: fontSizes,
      colorList: props.color,
      errorStatus: {
        state: false,
        msg: ''
      },
      floor: 4
    };

  }
  setError = (state, msg) => {
    this.setState({
      errorStatus: {
        state, msg
      }
    })
  }
  handleChange (type, e) {
    this.setState({
      [type]: e.target.value
    })
  }

  handleClick = () => {
    const { onChange } = this.props;
    const { list, colorList, fontSizes, floor} = this.state;

    let result = {
      labelList: [],
      list: [],
      colorList,
      fontSizes,
      floor
    }
    let errorStatus = false
    list.forEach((item, index) => {
      if (!item.name) {
        errorStatus = true 
      }
      result.labelList.push(item.name)
      const _arr = concat(item.arr0, item.arr1, item.arr2, item.arr3)
      result.list.push(_arr)
    })
    
    if (errorStatus) {
      setTimeout(() => {
        this.setError(false, '')
      }, 2000)
      return this.setError(true, '请输入正确数据')
    }

    onChange({}, result);
  }


  dataOnChange = (index, key, e) => {
    const {list} = this.state

    list[index][key] = e.target.value
    this.setState({
      list
    })
  }

  /**
   * 删除一条数据
   * @memberof KeyValuePie
   */
  removeItem = (index) => {
    let {list} = this.state
    list.splice(index, 1)
    this.setState({
      list
    })
  }

  /**
   * 新增条数据
   * @memberof KeyValuePie
   */
  addItem = () => {
    let {list} = this.state
    list.push({
      name: '',
      arr: []
    })

    this.setState({
      list
    })
  }

  /**
   * 颜色修改
   * @memberof KeyValuePie
   */
  colorChange = (index, floor, val) => {
    const {colorList} = this.state
    if (!colorList[index]) {
      colorList[index] = ['#dc8a03', '#f19601', '#f7ba5f', '#fcddb1']
    }
    colorList[index][floor] = val
    this.setState({colorList})
  }

  /**
   * 批量修改颜色
   * @memberof KeyValuePie
   */
  colorsChange = (index, val) => {
    const {colorList, colors} = this.state
    const colorVal = val === '' ? ['#fff', '#fff', '#fff', '#fff'] : colors[val].value

    colorList[index] = colorVal
    this.setState({colorList})
  }

  onFontSizeChange = (i,val) => {
    const { fontSizes } = this.state
    fontSizes[i] = parseInt(val)
    this.setState({
      fontSizes: [...fontSizes] 
    })
  }

  render () {
    const {list, colorList, colors, errorStatus, fontSizes, floor } = this.state;
    const colorListLen = colorList.length

    return (
      <Collapse className={s.collapse}>
        <Panel header="字体大小">
          {fontSizes.map((ele, index) => {
            return <label style={{display: 'block'}}>
              <span>第{num2Str[index]}层</span>
              <input type="number" key={index}
                value={ele} 
                style={{width: 100, ...inputStyle}} 
                onChange={e => this.onFontSizeChange(index, e.target.value)} 
              />
            </label>
          })}
        </Panel>
        <Panel header="数据" expand>

          <div>
            <label>认知关键词层级：</label>
            <select value={floor} style={{width: 100}}
              onChange={e => this.setState({floor: e.target.value})}
            >
              <option value={3}>三层</option>
              <option value={4}>四层</option>
            </select>
            <p>
              <span>如果使用三层环形的解构将会自动省略第四层数据</span>
            </p>
          </div>

          <p style={{color: '#f00', margin: '0'}}>* <code>/s代表一个空格，/n代表换行</code></p>
          <div>
          {
            list.map((item,index) => (
              <div key={index} style={{borderBottom: '1px solid #ccc', paddingBottom: 10, marginBottom: 10}}>
                <input 
                  value={item.name} 
                  style={{width: 100, ...inputStyle}} 
                  onChange={e => this.dataOnChange(index, 'name', e)} 
                />
                
                <button style={inputStyle} onClick={() =>this.removeItem(index)}>删除</button>
                <select style={inputStyle} onChange={e => this.colorsChange(index, e.target.value)}>
                  <option value="">自定义颜色</option>
                  {colors.map((item, index) => <option 
                    key={index} 
                    value={index}
                    style={{
                      backgroundColor: item.value[0],
                      backgroundClip: 'content-box'
                    }}
                  >{item.name}</option>
                  )}
                </select>
                
                <br/>
                <div style={{display: 'flex'}}>
                  <div>
                    第一层<MysketchPicker onChange={val => this.colorChange(index, 0, val)} value={colorList[index%colorListLen][0]} />
                    <textarea value={item.arr0} rows={5} cols={15} onChange={e => this.dataOnChange(index, 'arr0', e)} />
                  </div>
                  <div>
                    第二层<MysketchPicker onChange={val => this.colorChange(index, 1, val)} value={colorList[index%colorListLen][1]} />
                    <textarea value={item.arr1} rows={5} cols={15} onChange={e => this.dataOnChange(index, 'arr1', e)} />
                  </div>
                  <div>
                    第三层<MysketchPicker onChange={val => this.colorChange(index, 2, val)} value={colorList[index%colorListLen][2]} />
                    <textarea value={item.arr2} rows={5} cols={15} onChange={e => this.dataOnChange(index, 'arr2', e)} />
                  </div>
                  <div>
                    第四层<MysketchPicker onChange={val => this.colorChange(index, 3, val)} value={colorList[index%colorListLen][3]} />
                    <textarea value={item.arr3} rows={5} cols={15} onChange={e => this.dataOnChange(index, 'arr3', e)} />
                  </div>
                </div>
              </div>
            ))
          }
          <button onClick={this.addItem}>增加新数据+</button>
          </div>
          <hr/>
          {errorStatus.state && <p style={{color: '#f00'}}>{errorStatus.msg}</p>}

          <button type="primary" onClick={this.handleClick}>添加</button>
        </Panel>
      </Collapse>
    )
  }
}



export default withStyles(s)(KeyValuePie)


// WEBPACK FOOTER //
// src/routes/customChart/components/KeyValuePie.js